import store from '@/store';
import { leaseType } from '@/util/dictList.js'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      display: false,
      search: true,
      searchOrder: 444,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      display: false,
      searchOrder: 777,
    },
    {
      label: '所属代理商',
      prop: 'createDeptName',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: "所属代理商",
      prop: "createDepts",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      display: false,
      search: true,
      showColumn: false,
      hide: false,
      dicData: store.getters.porductTypes,
      searchOrder: 888
    },

    {
      label: '车牌号',
      prop: 'carFirstNumber',
      search: true,
      searchOrder: 666,
    },

    {
      label: '租期',
      prop: 'tenancy',
      type: 'select',
      display: false,
      // search: true,
      showColumn: false,
      dicData: leaseType,
    },
    {
      label: '租率',
      prop: 'lendingRate',
      span: 24,
      display: false,
      searchOrder: 1000,
      formatter:(val,value)=>{
        return value ? value + "%" : "";
      }
    },
    {
      label: '起租日',
      prop: 'commencementDate',
    },
    {
      label: '起租日',
      prop: 'commencementDateStr',
      type: 'daterange',
      search: true,
      searchRange: true,
      dataType: 'string',
      valueFormat: 'yyyy-MM-dd',
      searchTip: '最多支持60天的区间查询',
      searchTipPlacement: 'top',
      hide: true,
      searchOrder: 555,
    },
  ],
};

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '租赁人',
      value: 'name',
      order: 1,
    },
    {
      title: '所属代理商',
      value: 'createDeptName',
      order: 2,
    },
    {
      title: '产品类型',
      value: 'rentType',
      order: 3,
    },
    {
      title: '租期',
      value: 'tenancy',
      order: 4,
    },
    {
      title: '平台',
      value: 'platformName',
      order: 5,
    },
    {
      title: '平台金额',
      value: 'platformAmount',
      order: 6,
    },
    {
      title: '平台利率',
      value: 'platformRate',
      order: 7,
    },
    {
      title: '平台期数',
      value: 'repayment',
      order: 8,
    },
    {
      title: '还款方式',
      value: 'repaymentMethod',
      order: 9,
    },
    {
      title: '还款日期',
      value: 'repaymentDate',
      order: 10,
    },
    {
      title: '每期还款金额',
      value: 'platformRepaymentAmount',
      order: 11,
    },
  ],
};
